/* rc-klaviyo — open a Klaviyo onsite/popup form by ID when a [data-rc-klaviyo]
   CTA is clicked. Event-delegated + idempotent; load once with defer.
   The element's data-rc-klaviyo value is the Klaviyo form ID. */
(function () {
  if (window.__rcKlaviyoInit) return;
  window.__rcKlaviyoInit = true;
  /* Analytics: enquiry-open event to GTM dataLayer + GA4 gtag (if present), tagged with the
     horizontal-scroll variant when that section is on the page (for A/B measurement). */
  function rcTrack(name, params) {
    var p = params || {};
    try {
      if (window.__rcHscrollTracked) p.rc_variant = 'horizontal';
      var dl = { event: name }; for (var k in p) dl[k] = p[k];
      (window.dataLayer = window.dataLayer || []).push(dl);
      if (typeof window.gtag === 'function') window.gtag('event', name, p);
    } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-rc-klaviyo]');
    if (!el) return;
    var id = el.getAttribute('data-rc-klaviyo');
    if (!id) return;
    e.preventDefault();
    rcTrack('enquiry_open', { method: 'klaviyo', rc_form_id: id });
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', id]);
  });
})();
